import React, { Component } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import Select from 'react-select';
import CopyToClipboard from 'react-copy-to-clipboard';
import { toastr } from 'react-redux-toastr';
import { show } from 'redux-modal';
import { Tabs, Tab } from 'react-bootstrap';
import { PublisherApi } from '../../../../api';
import { ContentHolder } from '../../../../components/common';
import { humanize } from '../../../../utils/helpers/text_formatters';
import EmailPixel from '../../../../components/publisher/pixel/EmailPixel';
import APIPixel from '../../../../components/publisher/pixel/APIPixel';
import SearchAPI from '../../../../components/publisher/pixel/SearchAPI';
import { ButtonCopy } from '../../../../components/common/buttons';

class PixelEdit extends Component {
  state = {
    key: 1,
    selectedTemplate: '',
    eventSnippet: '',
    placementSnippet: ''
  };

  componentDidMount() {
    this.fetchResource();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.website.uuid !== this.props.website.uuid) {
      this.fetchResource();
    }
    if (this.props.template.updated_at !== prevProps.template.updated_at) {
      this.updateTemplateInstructions(this.props.template);
      this.getTemplateOptions();
      this.setState({ selectedTemplate: { value: this.props.template, label: this.props.template.name } });
    }
  }

  getTemplateOptions() {
    const { templates } = this.props;

    const options = templates ? templates.map((element) => {
      return ({ value: element, label: `${element.name}` });
    }) : [];
    return options;
  }

  getAuctionEventString(templateId) {
    const { pixel } = this.props;
    const eventSnippet = get(pixel, 'data.event_snippet', null);

    return eventSnippet ? eventSnippet.replace('###TEMPLATE_ID###', templateId) : '';
  }

  getAdSlotString(numberOfSlots, templateSlug) {
    const { pixel } = this.props;
    const placementSnippet = get(pixel, 'data.placement_snippet', null);

    let slotsByPlacementSnippet = '';
    if (placementSnippet) {
      for (let index = 1; index <= numberOfSlots; index++) {
        slotsByPlacementSnippet += `${placementSnippet.replace('###SLOT_NUMBER###', index).replace('###TEMPLATE_SLUG###', templateSlug)}`;
        if (!(index === numberOfSlots)) {
          slotsByPlacementSnippet += '\n';
        }
      }
    }

    return slotsByPlacementSnippet;
  }

  fetchResource(params = {}) {
    const { website, dispatch } = this.props;
    const pixel = get(this.props, 'pixel.data', {});
    if (website.uuid && pixel.publisher_website_id !== website.uuid) {
      const data = { ...params, publisher_website_id: website.uuid };
      dispatch(PublisherApi.actions.pixel.get(data));
      dispatch(PublisherApi.actions.templates.get(data));
    }
  }

  handleSettings() {
    const { dispatch } = this.props;
    const { selectedTemplate } = this.state;

    dispatch(show('TemplateFormModal', {
      template: selectedTemplate.value,
      heading: `Template Settings - ${selectedTemplate.value.name}`,
      formAction: 'Update'
    }));
  }

  handleTabSelect(key) {
    this.setState({ key });
  }

  handleOnTemplateChange(selectedTemplate) {
    if (selectedTemplate) {
      this.setState({ selectedTemplate });
      this.updateTemplateInstructions(selectedTemplate.value);
    } else {
      this.setState({ selectedTemplate: '' });
    }
  }

  updateTemplateInstructions(selectedTemplate) {
    this.setState({ eventSnippet: this.getAuctionEventString(selectedTemplate.uuid) });
    this.setState({ placementSnippet: this.getAdSlotString(selectedTemplate.slots, selectedTemplate.slug) });
  }

  render() {
    const { pixel, isLoading, website } = this.props;
    const { selectedTemplate, eventSnippet, placementSnippet } = this.state;
    const mainSnippet = get(pixel, 'data.main_snippet', null);
    const widgetSnippet = get(pixel, 'data.widget_snippet', null);
    const pixelStatus = get(pixel, 'data.status', null);
    const pixelId = get(pixel, 'data.uuid', null);

    return (
      <div className='ibox'>
        <div className='ibox-title'>
          <h5>Pixel</h5>
        </div>
        <div className='ibox-content'>
          <ContentHolder loading={isLoading}>
            <div>
              <h4>Pixel ID : <span style={{ color: '#3c763d' }}>{pixelId}</span> </h4><br />
              <Tabs
                activeKey={this.state.key}
                onSelect={this.handleTabSelect.bind(this)}
                id="controlled-tab"
              >
                <Tab eventKey={1} title="Javascript Ad Pixel" className='p-md'>
                  <div className={`alert alert-${pixelStatus === 'active' ? 'success' : 'warning'}`}>
                    <strong>
                      The pixel is in {humanize(pixelStatus).toLowerCase()} state on: {website.url}
                    </strong>
                  </div>

                  <h3>1. Locate the body code for your website</h3>

                  <p>
                    Find the the body template in your CMS or web platform.
                  </p>

                  <pre id="pixel-example" className="m-t-md">
                    &lt;!-- Example --&gt;<br />
                    !DOCTYPE html&gt;<br />
                    &lt;html lang="en"&gt;<br />
                    &lt;head&gt;
                    &lt;/head&gt;<br />
                    &lt;body&gt;<br />
                    &lt;script&gt;...&lt;/script&gt;<br />
                    insert_pixel_code_here<br />
                    &lt;/body&gt;<br />
                    &lt;/html&gt;<br />
                  </pre><br />

                  <h3>2. Copy the entire pixel code and paste it in the website body</h3>

                  <p>
                    Paste the pixel code at the bottom of the body section, just above
                    the closing &lt;/body&gt; tag. JobAdX pixel code can be added above or below
                    existing tracking tags (such as Google Analytics) in your site body.
                  </p>

                  <CopyToClipboard
                    text={mainSnippet}
                    onCopy={() => toastr.success('Script copied to clipboard!')}
                  >
                    <ButtonCopy
                      btnLabel='Copy to clipboard'
                    />
                  </CopyToClipboard>
                  <pre id="pixel-view" className="m-t-md">
                    {mainSnippet}
                  </pre> <br />


                  <h3>3. Trigger the auction event</h3>
                  <p>
                    Whenever a search for jobs is initiated on your website using a keyword and location,
                    an auction event needs to be triggered. Best way to do that is to place the
                    event code on your job results page as shown below.
                  </p>
                  <br />
                  <Select
                    placeholder="Select a template to continue"
                    options={this.getTemplateOptions()}
                    value={selectedTemplate}
                    onChange={this.handleOnTemplateChange.bind(this)}
                  />
                  {
                    selectedTemplate ? (
                      <div>
                        <br />
                        <CopyToClipboard
                          text={eventSnippet}
                          onCopy={() => toastr.success('Event code copied to clipboard!')}
                        >
                          <ButtonCopy
                            btnLabel='Copy to clipboard'
                          />
                        </CopyToClipboard>

                        <pre id="pixel-event" className="m-t-md">
                          {eventSnippet}
                        </pre> <br />

                        <p>
                          Add the event code just below the main pixel tag from STEP 2. This allows the event code
                          to load along with the pixel code when the page loads.
                        </p>

                        <pre id="pixel-event-example" className="m-t-md">
                          &lt;body&gt;<br />
                          &lt;script&gt;...&lt;/script&gt;<br />
                          pixel_code_here<br />
                          insert_event_code_here<br />
                          &lt;/body&gt;<br />
                        </pre> <br />

                        <h3>4. Set up ad slots</h3>

                        <p>
                          Place each of the following slot codes within the body of the html
                          where you want the respective slot to be displayed.
                        </p>

                        <p>
                          This template is currently configured for {selectedTemplate.value.slots} slot(s).
                          Please <a href='javascript:void(0);' onClick={this.handleSettings.bind(this)}>
                            click here
                          </a> to change this setting.
                        </p>

                        <CopyToClipboard
                          text={placementSnippet}
                          onCopy={() => toastr.success('Slot codes copied to clipboard!')}
                        >
                          <ButtonCopy
                            btnLabel='Copy to clipboard'
                          />
                        </CopyToClipboard>

                        <pre id="pixel-ad-placement" className="m-t-md">
                          {placementSnippet}
                        </pre> <br />

                        <p>
                          Add the placement codes anywhere between &lt;body&gt; and &lt;/body&gt; tags.
                        </p>
                        <pre id="pixel-placement-example" className="m-t-md">
                          &lt;body&gt;<br />
                          insert_placement_code_here<br />
                          &lt;/body&gt;
                        </pre>
                        <br />
                      </div>
                    ) : ''
                  }
                </Tab>

                <Tab eventKey={2} title="API Ad Pixel" className='p-md'>
                  <APIPixel pixel={pixel} website={website} />
                </Tab>

                <Tab eventKey={3} title="Job Search API" className='p-md'>
                  <SearchAPI pixel={pixel} website={website} />
                </Tab>

                <Tab eventKey={4} title="Email Pixel" className='p-md'>
                  <EmailPixel pixel={pixel} website={website} />
                </Tab>

                <Tab eventKey={5} title="Widget" className='p-md'>
                  <h3>Copy the entire snippet of code below and paste it in the website body</h3>

                  <p>
                    You can paste the widget code any where in the body, just above
                    the &lt;/body&gt; tag.
                  </p>

                  <CopyToClipboard
                    text={widgetSnippet}
                    onCopy={() => toastr.success('Script copied to clipboard!')}
                  >
                    <ButtonCopy
                      btnLabel='Copy to clipboard'
                    />
                  </CopyToClipboard>

                  <pre id="pixel-view" className="m-t-md">
                    {widgetSnippet}
                  </pre> <br />
                </Tab>
              </Tabs>
              <br />
              <p>
                If at any point you're stuck and need help installing the pixel,
                please drop us an email at <b>support@jobadx.com</b> and our technical support
                team will get in touch with you.
              </p>
            </div>
          </ContentHolder>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { publisher, publisher: { websites } } = state;
  const { params: { websiteName } } = ownProps;
  const website = (websites.data.data || [])
    .filter((w) => w.slug === websiteName)[0] || {};

  return {
    pixel: publisher.pixel.data,
    templates: publisher.templates.data.data,
    isLoading: publisher.pixel.loading,
    website,
    template: publisher.templates.data.template || {}
  };
};

export default connect(mapStateToProps)(PixelEdit);
